import Link from 'next/link';
import PropTypes from 'prop-types';

import {
  HeroLink,
  ImageWrapper,
  LinkWrapperStyled,
} from './PageHeroMedia.styled';

const LinkWrapper = ({ children, link }) => (
  <LinkWrapperStyled>
    {link?.href && link?.as ? (
      <>
        <Link
          legacyBehavior
          href={link.href}
          as={link.as}
          passHref
        >
          <HeroLink />
        </Link>
        <ImageWrapper>{children}</ImageWrapper>
      </>
    ) : (
      <ImageWrapper>{children}</ImageWrapper>
    )}
  </LinkWrapperStyled>
);

LinkWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  link: PropTypes.shape({
    href: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.shape({}),
    }),
    as: PropTypes.string,
  }),
};

LinkWrapper.defaultProps = {
  link: {
    href: undefined,
    as: undefined,
  },
};

export default LinkWrapper;
